// extracted by mini-css-extract-plugin
export default {"content":"DialogConfirmation--content--2e3935","icon":"DialogConfirmation--icon--4a90e6"};